module.exports = __webpack_public_path__ + "img/SKMA_smoke2.235f03b0.png";